import React from 'react'

const Header = function header (){
    return (
        <nav class="header">
            <div class="nav-wrapper">
                <a href="#" class="brand-logo"> 
                    Films H&D
                </a>
                <ul id="nav-mobile" class="right hide-on-med-and-down">
                </ul>
            </div>
        </nav>
    )
}

export default Header
